<template>
    <b-card :title="title">
        <b-card-header>
            <slot></slot>
        </b-card-header>
        <b-card-body>
            <b-table :fields="fields" striped hover responsive :items="items">
                <template #cell(id)="row">
                    <b-button
                        size="sm"
                        v-if="hasPermissionView"
                        @click="$emit('show-item', row.item.id)"
                        class="mr-2"
                        variant="primary"
                    >
                        View
                    </b-button>
                </template>
            </b-table>
        </b-card-body>
    </b-card>
</template>
<script>
import _ from 'lodash'

import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'


export default {
    name: 'ItemTypes-ListItems',
    props: ['type', 'items', 'title'],
    mixins: [popupMixins, permissionsMixins],
    data() {
        return {
            query: '',
            page: 1,
            fields: [
                { key: 'id', label: 'Actions' },
                'name',
                'description',
                'tax_rate',
                'uom',
                 'size_uom',
                'is_task',
                'is_order_item',
                //'is_asset',
                'is_discount',
            ],
        }
    },

    mounted() {},

    methods: {
        truncate(text, length) {
            return _.truncate(text, { length: length })
        },
    },

    computed: {
        user() {
            return this.$store.state.user
        },
        
    },
}
</script>
<style></style>
